<div class="new-dea-report-container">
  <div class="fixed-header">
    <div class="page-header-container">
      <div class="header-composed">
        <a routerLink="/reports/dea-compliance" class="text-title-2 back-ref">
          DEA Compliance
        </a>
        <div class="text-title-2 header">
          <app-badge *ngIf="report?.isBiennial">Biennial</app-badge>
          {{report?.title || 'Controlled Substance Inventory Report'}}
        </div>
      </div>
      <div *ngIf="report" class="header-composed-controls">
        <app-button *ngIf="!isSigned"
                    styleClass="settings"
                    subStyle="blue"
                    customClasses="px-4 mr-3"
                    [minWidth]="0"
                    [text]="'Sign Now'"
                    [loading]="isLoading$ | async" 
                    (clicked)="signReport()"
        ></app-button>

        <app-button [minWidth]="0"
                    customClasses="pl-4 pr-10"
                    [text]="'Download'"
                    appMenu
                    [loading]="isFileDownloading"
                    [placement]="'bottom-right'"
                    [autoClose]="'outside'"
                    [menuContent]="downloadMenuContent"
                    triggers="manual"
                    #downloadMenu="appMenu"
                    (click)="downloadMenu.toggle();$event.stopPropagation();"
        >
          <img [class.opened]="downloadMenu.isOpen()" class="download-btn-icon"
               src="assets/icons/icon-chevron-down-white.svg" alt="chevron-down"/>
        </app-button>
        <ng-template #downloadMenuContent>
          <div class="menu-container primary">
            <div (click)="savePDF();downloadMenu.close();$event.stopPropagation()"
                 class="menu-item"
            >
              <div class="option">Export as PDF</div>
            </div>
            <div (click)="saveCSV();downloadMenu.close();$event.stopPropagation()"
                 class="menu-item"
            >
              <div class="option">Save as CSV</div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="reports-details-header">
      Report Details
    </div>

    <div *ngIf="report" class="report-details-container">
      <div class="details-row">
        <div class="item">
          <div class="item-label">
            performed by
          </div>
          <div class="item-data">
            {{report.signerFirstName}}
            <ng-container *ngIf="report.signerLastName">{{report?.signerLastName}}
            </ng-container>
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            date
          </div>
          <div class="item-data">
            {{report.createDate | formattedDate: 'MMM dd, yyyy'}}
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            time
          </div>
          <div class="item-data">
            {{reportTime}}
          </div>
        </div>
        <div class="item" *ngIf="isGroupsMode">
          <div class="item-label">
            locations
          </div>
          <div class="item-data locations">
            {{locationsString}}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="item">
          <div class="item-label">
            Witnessed By
          </div>
          <div class="item-data">
            {{report.witness}}
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            DEA Number
          </div>
          <div class="item-data">
            {{report.deaNumber}}
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            DEA Registrant
          </div>
          <div class="item-data">
            {{report.deaRegistrant}}
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            DEA Registrant address
          </div>
          <div class="item-data">
            {{report?.deaRegistrantAddress}}<ng-container *ngIf="report?.deaRegistrantCityStateZip">, </ng-container>
            {{report?.deaRegistrantCityStateZip}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="group-controls">
    <div *ngIf="report?.details?.length" class="controls-wrapper">
        <div class="heading">
          Results
        </div>
        <app-button [text]="'By NDC'"
          styleClass="toggle"
          [disabled]="isLoading$ | async"
          [subStyle]="groupResultsBy === GroupedBy.Drug? 'active' : 'unactive'"
          [minWidth]="0"
          customClasses="px-3 mr-8"
          (clicked)="switchFilterResultBy(GroupedBy.Drug)"
        ></app-button>
        <app-button class="similar"
          [text]="'By Similar'"
          styleClass="toggle"
          [disabled]="isLoading$ | async"
          [subStyle]="groupResultsBy === GroupedBy.GPI ? 'active' : 'unactive'"
          [minWidth]="0"
          customClasses="px-3 ml-8"
          (clicked)="switchFilterResultBy(GroupedBy.GPI)"
        ></app-button>
      </div>
  </div>
  
  <div *ngIf="report" class="table-scroll-wrapper">
    <table class="table-primary new-dea-report-table">
      <thead>
        <tr>
          <th *ngIf="groupResultsBy === GroupedBy.GPI"
            class="text-left drug" (click)="sortByColumn('friendlyName')">
            DRUG
            <img [class.asc]="tableColumns.friendlyName" class="sort-icon"
              src="assets/icons/icon-arrow-down.svg" alt="asc"
            />
          </th>
          <th (click)="sortByColumn('friendlyName')" *ngIf="!isGroupsMode"
            class="text-left sort name" scope="col">
            Name
            <img [class.asc]="tableColumns.friendlyName" class="sort-icon"
                src="assets/icons/icon-arrow-down.svg" alt="asc"
            />
          </th>
          <th (click)="sortByColumn('locationName')" *ngIf="isGroupsMode" 
            class="text-left sort name" scope="col">
            Location
            <img [class.asc]="tableColumns.locationName" class="sort-icon"
              src="assets/icons/icon-arrow-down.svg" alt="asc"
            />
          </th>
          <th class="text-left manufacturer" scope="col">Manufacturer</th>
          <th class="text-left strength" scope="col">Strength</th>
          <th class="text-left form" scope="col">Form</th>
          <th class="text-right pkg-qty" scope="col">Pkg Size</th>
          <th class="text-right full-pkg" scope="col">Full pkg</th>
          <th class="text-right open-pkg" scope="col">Open pkg</th>
          <th class="text-right part-pkg" scope="col">Open qty</th>
          <th class="text-right total" scope="col">Total</th>
          <!-- Controls -->
          <th class="text-right controls" scope="col"></th>
        </tr>
      </thead>
      <!--Inventory locations OFF view-->
      <tbody *ngIf="!isGroupsMode">
        <tr class="table-row" *ngFor="let record of report.details; let i = index; trackBy: trackDeaRecordsById">
          <td class="text-left name">
            <div class="heading header">{{record.friendlyName}}</div>
            <div class="secondary">{{record.packageNdc}}</div>
          </td>
          <td class="text-left manufacturer">
            {{record.manufacturer}}
          </td>
          <td class="text-left strength">
            {{record.strength}}
          </td>
          <td class="text-left form">
            {{record.form}}
          </td>
          <td class="text-right pkg-qty">
            {{record.packageQuantity}}
          </td>
          <td class="text-right full-pkg">
            <ng-container *ngIf="!editRowOptions[i].isEdit">{{record.fullPackages}}</ng-container>

            <app-input [textAlign]="'right'"
                      *ngIf="editRowOptions[i].isEdit"
                      type="number"
                      class="full-pkg-input"
                      [naturalNumbersOnly]="true"
                      [showFocusedErrorBorder]="true"
                      [(ngModel)]="editRowOptions[i].fullPkg"
                      [autoselect]="editRowOptions[i].isEdit"
                      [invalid]="validateFullPkgInput(i)"
                      (keydownTab)="openPkgInput.focusInput()"
                      (blurred)="onPackagingChange(i)"
                      placeholder="0"
                      [tabIndex]="3"
                      #fullPkgInput
            ></app-input>
          </td>
          <td class="text-right open-pkg">
            <ng-container *ngIf="!editRowOptions[i].isEdit">{{record.partialPackages}}</ng-container>

            <app-input [textAlign]="'right'"
                      *ngIf="editRowOptions[i].isEdit"
                      type="number"
                      class="open-pkg-input"
                      [naturalNumbersOnly]="true"
                      [showFocusedErrorBorder]="true"
                      [(ngModel)]="editRowOptions[i].partialPackages"
                      [invalid]="validateOpenPkgInput(i)"
                      (keydownTab)="focusButton('closeBtn')"
                      (blurred)="onPackagingChange(i)"
                      placeholder="0"
                      [tabIndex]="4"
                      #openPkgInput
            ></app-input>
          </td>
          <td class="text-right part-pkg">
            <ng-container *ngIf="!editRowOptions[i].isEdit">
            {{record.partialPackageQuantity}}
            </ng-container>
            <ng-container *ngIf="editRowOptions[i].isEdit">
              {{editRowOptions[i].partialPackageQuantity}}
            </ng-container>
          </td>
          <td class="text-right total">
            {{record.total | number: '.0'}}
          </td>
          <td class="text-left controls">
            <app-button *ngIf="!isSigned && !editRowOptions[i].isEdit"
                        (clicked)="setDetailsRowEditMode(i)"
                        class="edit-btn float-right"
                        subStyle="white"
                        [minWidth]="60"
                        customClasses="px-4"
                        text="Edit"
            ></app-button>

            <div class="edit-controls flex justify-between" *ngIf="editRowOptions[i].isEdit">
              <app-button (click)="cancelDetailsRowChanges(i)"
                          class="close-btn"
                          subStyle="white"
                          customClasses="mr-2"
                          [minWidth]="38"
                          (keydownTab)="focusButton('saveBtn')"
                          [tabIndex]="1"
                          #closeBtn
              >
                <img class="control-icon icon-remove animation-focus-default"
                    src="assets/icons/icon-remove-gray.svg"
                    alt="remove-icon"
                />
              </app-button>

              <app-button (click)="saveDetailsRowChanges(i)"
                          class="save-btn"
                          styleClass="settings"
                          subStyle="blue"
                          customClasses="px-0 w-[38px] focus:ring-offset-2 focus:ring-2 ring-color-primary"
                          [minWidth]="38"
                          (keydownTab)="fullPkgInput.focusInput()"
                          [tabIndex]="0"
                          #saveBtn
              >
                <img class="control-icon icon-check animation-focus-default"
                    src="assets/icons/icon-check-default.svg"
                    alt="check-icon"
                />
              </app-button>
            </div>
          </td>
        </tr>
      </tbody>
 <!--Inventory locations ON view-->
      <tbody *ngIf="isGroupsMode">
        <ng-container *ngFor="let group of report.details; let groupIndex = index">
          <tr class="group-header-container" 
            (click)="groupItemsOpened[groupIndex] = !groupItemsOpened[groupIndex]">
            <td colspan="3" class="header">
              <img [class.close]="!groupItemsOpened[groupIndex]" class="icon-toggle"
                   src="assets/icons/icon-toggle-chevron-green.svg"
                   alt="toggle-icon"/>
              <div class="group-header">
               <div>{{group.header}}</div> 
              </div>
            </td>
            <td class="text-right pkg-qty"></td>
            <td class="text-right full-pkg">{{group.fullPkgTotalPerGroup}}</td>
            <td class="text-right open-pkg">{{group.openPkgTotalPerGroup}}</td>
            <td class="text-right part-pkg">{{group.openQtyTotalPerGroup}}</td>
            <td class="text-right total">{{group.totalPerGroup}}</td>
            <td class="text-left controls"></td>
          </tr>
          <ng-container *ngIf="groupItemsOpened[groupIndex]">
            <tr class="table-row" *ngFor="let record of group?.entries; let i = index; trackBy: trackDeaRecordsById">
              <td class="text-left drug" *ngIf="groupResultsBy === GroupedBy.GPI">
                <div class="heading">
                  {{record?.friendlyName}}
                </div>
                <div class="secondary">
                  {{record?.packageNdc}}
                </div>
              </td>
              <td class="text-left name">
                {{record.locationName}}
              </td>
              <td class="text-left manufacturer">
                {{record.manufacturer}}
              </td>
              <td class="text-left strength">
                {{record.strength}}
              </td>
              <td class="text-left form">
                {{record.form}}
              </td>
              <td class="text-right pkg-qty">
                {{record.packageQuantity}}
              </td>
              <td class="text-right full-pkg">
                <ng-container *ngIf="!editRowOptions[record.flatArrayItemIndex].isEdit">{{record.fullPackages}}</ng-container>
                <app-input [textAlign]="'right'"
                          *ngIf="editRowOptions[record.flatArrayItemIndex].isEdit"
                          type="number"
                          class="full-pkg-input"
                          [naturalNumbersOnly]="true"
                          [showFocusedErrorBorder]="true"
                          [(ngModel)]="editRowOptions[record.flatArrayItemIndex].fullPkg"
                          [autoselect]="editRowOptions[record.flatArrayItemIndex].isEdit"
                          [invalid]="validateFullPkgInput(record.flatArrayItemIndex)"
                          (keydownTab)="openPkgInput.focusInput()"
                          (blurred)="onPackagingChangeInGroup(groupIndex, i, record.flatArrayItemIndex)"
                          placeholder="0"
                          [tabIndex]="3"
                          #fullPkgInput
                ></app-input>
              </td>
              <td class="text-right open-pkg">
                <ng-container *ngIf="!editRowOptions[record.flatArrayItemIndex].isEdit">{{record.partialPackages}}</ng-container>

                <app-input [textAlign]="'right'"
                          *ngIf="editRowOptions[record.flatArrayItemIndex].isEdit"
                          type="number"
                          class="open-pkg-input"
                          [naturalNumbersOnly]="true"
                          [showFocusedErrorBorder]="true"
                          [(ngModel)]="editRowOptions[record.flatArrayItemIndex].partialPackages"
                          [invalid]="validateOpenPkgInput(record.flatArrayItemIndex)"
                          (keydownTab)="focusButton('closeBtn')"
                          (blurred)="onPackagingChangeInGroup(groupIdex, i, record.flatArrayItemIndex)"
                          placeholder="0"
                          [tabIndex]="4"
                          #openPkgInput
                ></app-input>
              </td>
              <td class="text-right part-pkg">
                <ng-container *ngIf="!editRowOptions[record.flatArrayItemIndex].isEdit">
                {{record.partialPackageQuantity}}
                </ng-container>
                <ng-container *ngIf="editRowOptions[record.flatArrayItemIndex].isEdit">
                  {{editRowOptions[record.flatArrayItemIndex].partialPackageQuantity}}
                </ng-container>
              </td>
              <td class="text-right total">
                {{record.total | number: '.0'}}
              </td>
              <td class="text-left controls">
                <app-button *ngIf="!isSigned && !editRowOptions[record.flatArrayItemIndex].isEdit"
                            (clicked)="setDetailsRowEditMode(record.flatArrayItemIndex)"
                            class="edit-btn float-right"
                            subStyle="white"
                            [minWidth]="60"
                            customClasses="px-4"
                            text="Edit"
                ></app-button>

                <div class="edit-controls flex justify-between" *ngIf="editRowOptions[record.flatArrayItemIndex].isEdit">
                  <app-button (click)="cancelDetailsRowChanges(record.flatArrayItemIndex)"
                              class="close-btn"
                              subStyle="white"
                              customClasses="mr-2"
                              [minWidth]="38"
                              (keydownTab)="focusButton('saveBtn')"
                              [tabIndex]="1"
                              #closeBtn
                  >
                    <img class="control-icon icon-remove animation-focus-default"
                        src="assets/icons/icon-remove-gray.svg"
                        alt="remove-icon"
                    />
                  </app-button>

                  <app-button (click)="saveDetailsRowChanges(record.flatArrayItemIndex)"
                              class="save-btn"
                              styleClass="settings"
                              subStyle="blue"
                              customClasses="px-0 w-[38px] focus:ring-offset-2 focus:ring-2 ring-color-primary"
                              [minWidth]="38"
                              (keydownTab)="fullPkgInput.focusInput()"
                              [tabIndex]="0"
                              #saveBtn
                  >
                    <img class="control-icon icon-check animation-focus-default"
                        src="assets/icons/icon-check-default.svg"
                        alt="check-icon"
                    />
                  </app-button>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>

      <tfoot *ngIf="report?.details?.length">
      <tr *ngIf="report != null && report.details != null">
        <td class="text-left records-count">
          {{report.details.length}} Record{{report.details.length > 1 ? 's' : ''}}
        </td>
      </tr>
      </tfoot>
    </table>
  </div>

  <app-alert class="dea-record-error-alert"
             maxWidth="auto"
             [show]="showMessage"
             [hideCloseButton]="true"
             [type]="alertMessage?.type"
             [message]="alertMessage?.text"
             (closeAlert)="showMessage = false"
             [autohide]="autohideDelay"
  ></app-alert>
</div>

<app-enter-pin-with-signature-stepper-dialog *ngIf="collectSignaturesAndPinsDialog"
 (save)="afterSignatureAndPinCollectionHandled($event)"
 (cancel)="collectSignaturesAndPinsDialog = false"
></app-enter-pin-with-signature-stepper-dialog>
